query getBrInvoiceDownloadUrl($input: GetBrInvoiceDownloadUrlInput!) {
  brInvoiceDownloadUrl: getBrInvoiceDownloadUrl(input: $input)
}
